.input {
  :global(.ant-input-prefix) {
    margin-inline-end: var(--space-2);
  }

  :global(.ant-input-suffix) {
    margin-inline-start: var(--space-2);
  }
}

.affixText {
  font-size: 14px;
  font-weight: 300;
  color: var(--text-secondary);
}
